import {Comment} from '../../models';

export interface CommentsResponse {
  totalCount: number;
  count: number;
  comments: Comment[];
}
